import { MEDIA_QUERIES } from '@student-coin/coinpaper-components';
import tw, { styled } from 'twin.macro';
import { Container as AuthorNote } from '../AuthorNote/AuthorNote.styles';
import { Container as ShareArticle } from '../ShareArticle/ShareArticle.styles';

export const Container = styled.div`
  ${tw`col-start-1 col-span-12 md:col-start-2 md:col-span-10  2xl:col-span-full 2xl:col-start-1`};

  ${AuthorNote} {
    margin-top: 2rem;
  }

  ${ShareArticle} {
    padding: 1.5rem 0;

    @media ${MEDIA_QUERIES.tablet} {
      padding: 3.625rem 0;
    }
  }
`;

export const AffiliateLinksWrapper = styled.div`
  margin-bottom: 24px;
`;

export const NewsletterContainer = styled.div`
  position: relative;
  margin-top: 25px;
  & > div {
    margin: 0;
    width: 100%;
    grid-gap: 15px;
    padding: 32px 20px;
  }
  h3 {
    font-size: 27px;
  }
`;
